const hasLetters = (value) => /\p{Letter}/u.test(value);

const normalizeToken = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "");

const getEmailLocalPart = (email) =>
  String(email || "")
    .trim()
    .toLowerCase()
    .split("@")[0];

export const isCertificateNameMissingOrPlaceholder = (fullName, email) => {
  const name = String(fullName || "").trim();
  if (!name || !hasLetters(name)) return true;
  if (name.includes("@")) return true;

  const emailLocalPart = getEmailLocalPart(email);
  if (!emailLocalPart) return false;

  const lowerName = name.toLowerCase();
  if (lowerName === emailLocalPart) return true;

  // Signup/invite flows save the email local part exactly, including dots or
  // underscores. Treat those machine-created values as missing certificate names.
  const hasWhitespace = /\s/.test(name);
  return !hasWhitespace && normalizeToken(name) === normalizeToken(emailLocalPart);
};

export const getCertificateProfileMissingFields = (user) => {
  const missingFields = [];
  if (isCertificateNameMissingOrPlaceholder(user?.full_name, user?.email)) {
    missingFields.push("Name");
  }
  if (!user?.email?.trim()) missingFields.push("Email");
  if (!user?.highest_qualification?.trim()) {
    missingFields.push("Highest Qualification");
  }
  return missingFields;
};

export const getCertificateRecipientName = (user) => {
  if (isCertificateNameMissingOrPlaceholder(user?.full_name, user?.email)) {
    return null;
  }
  return String(user?.full_name || "").trim() || null;
};
